export function Chip({ active = false, className = "", ...props }) {
  const base =
    "rounded-full border px-3 py-1.5 text-sm font-medium transition " +
    "disabled:cursor-not-allowed disabled:opacity-50";

  const style = active
    ? "border-dulia-navy bg-dulia-navy text-white shadow-soft " +
      "dark:border-dulia-gold dark:bg-dulia-gold dark:text-dulia-night"
    : "border-dulia-line bg-dulia-panel text-dulia-navy hover:bg-dulia-parchment " +
      "dark:border-dulia-lineStrong/30 dark:bg-dulia-nightSoft dark:text-dulia-parchment dark:hover:bg-dulia-night";

  return (
    <button
      type="button"
      className={`${base} ${style} ${className}`}
      {...props}
    />
  );
}